import { useEffect } from 'react';
import { view, textFormatting, bowser } from '@yola/ws-sdk';
import helpers from '../helpers';

const {
  applySelectionWrapper,
  undoSelectionWrapper,
  makeTextSelectable,
  removeTextSelectable,
  restoreRange,
} = helpers;

const withSelectionWrapper = !bowser.firefox;
const withTextSelectableAttribute = bowser.safari || bowser.firefox;

const useSelectionSimulation = (elementId) => {
  const applySimulation = () => {
    if (withSelectionWrapper) applySelectionWrapper();
  };

  const undoSimulation = () => {
    if (withSelectionWrapper) undoSelectionWrapper(view.accessors.getLiveElement(elementId));
  };

  const clearSelectionImitation = () => {
    undoSimulation();
  };

  const restoreSelectionImitation = () => {
    applySimulation();
  };

  useEffect(() => {
    const element = view.accessors.getLiveElement(elementId);

    if (withTextSelectableAttribute) {
      makeTextSelectable(elementId);
    }

    applySimulation();

    element.blur();
    element.setAttribute('contenteditable', 'false');

    return () => {
      undoSimulation(element);

      const liveElement = view.accessors.getLiveElement(elementId);
      liveElement.setAttribute('contenteditable', true);
      liveElement.focus();

      if (bowser.ios || bowser.iPadOS) {
        restoreRange(textFormatting.accessors.getAdvancedSelection(), elementId);
      }

      if (withTextSelectableAttribute) {
        removeTextSelectable(elementId);
      }
    };
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  return {
    clearSelectionImitation,
    restoreSelectionImitation,
  };
};

export default useSelectionSimulation;
